import { useState } from 'react';
import { Link, createFileRoute, useNavigate } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api/client';
import { AuthLayout } from '@bounded/ui/auth-layout';
import { Button, Field, Input } from '@bounded/ui/primitives';
import { ErrorNotice } from '@bounded/ui/state';
import { useT } from '../i18n';

// The email link passes through /api/auth/reset-password/:token, which redirects here with ?token= (or ?error= if it was bad).
export const Route = createFileRoute('/reset-password')({
  validateSearch: (s): { token?: string; error?: string } => ({ token: typeof s.token === 'string' ? s.token : undefined, error: typeof s.error === 'string' ? s.error : undefined }),
  component: Reset,
});

function Reset() {
  const t = useT(); const m = t.auth.reset;
  const { token, error } = Route.useSearch();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const reset = useMutation({ mutationFn: () => api.resetPassword(token!, password), onSuccess: () => navigate({ to: '/sign-in', search: { notice: 'reset' } }) });
  if (!token || error) {
    return <AuthLayout title={m.badTitle}><p className="text-graphite">{m.badBody}</p><Link to="/forgot-password" className="text-boundary hover:underline">{m.requestNew}</Link></AuthLayout>;
  }
  const mismatch = confirm.length > 0 && confirm !== password;
  return (
    <AuthLayout title={m.title}>
      <form className="grid gap-5" onSubmit={(e) => { e.preventDefault(); reset.mutate(); }}>
        {reset.error && <ErrorNotice error={reset.error} />}
        <Field label={m.password} htmlFor="password" hint={m.passwordHint}>
          <Input id="password" type="password" autoComplete="new-password" required minLength={12} value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Field label={m.confirm} htmlFor="confirm" hint={mismatch ? m.mismatch : undefined}>
          <Input id="confirm" type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </Field>
        <Button type="submit" variant="primary" disabled={reset.isPending || password.length < 12 || confirm !== password}>{m.submit}</Button>
      </form>
    </AuthLayout>
  );
}
